import { render, staticRenderFns } from "./DecisionMaking.vue?vue&type=template&id=2fffac12&scoped=true"
import script from "./DecisionMaking.vue?vue&type=script&lang=js"
export * from "./DecisionMaking.vue?vue&type=script&lang=js"
import style0 from "./DecisionMaking.vue?vue&type=style&index=0&id=2fffac12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fffac12",
  null
  
)

export default component.exports